import { render } from "./UnderstandingDigu.vue?vue&type=template&id=eb70d3f6&scoped=true"
import script from "./UnderstandingDigu.vue?vue&type=script&lang=js"
export * from "./UnderstandingDigu.vue?vue&type=script&lang=js"

import "./UnderstandingDigu.vue?vue&type=style&index=0&id=eb70d3f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb70d3f6"]])

export default __exports__